module.exports = __webpack_public_path__ + "img/new-autosense-logo.935a2eeb.png";